/*Tps-report*/
if(window.location.pathname.includes("reports/on-hold")){

    var options = {
        autoWidth: false,
        columnDefs: [
            {
                width: "10%",
                targets: "_all"
            },
            {
                render: function(data, type, row) {
                    return "<a href='/placement/edit/"+row.id+"'>"+data+"</a>";
                },
                targets: 0
            },
        ],
        buttons: [
            {extend:"excel", text: '<i class="fas fa-file-download"></i>'}
        ]
    };

    $.each($(".data-table"), function(){
        $(this).data("options", options);
    });

}



// WEBPACK FOOTER //
// ./resources/assets/js/pages/reports/on-hold.js